'use client'

import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

import ViverseButton from '@/components/ViverseButton'

export default function PartnershipCtaSection() {
  const t = useTranslations()

  return (
    <section className="px-6 py-10 sm:px-8 sm:py-14">
      <motion.div
        className="mx-auto max-w-[1194px] overflow-hidden rounded-3xl px-6 py-14 sm:px-8 sm:py-20"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="mx-auto flex max-w-[704px] flex-col items-center text-center">
          <h2 className="text-2xl leading-8 font-extrabold tracking-[0.1px] text-[#eeeef0] sm:text-3xl sm:leading-10">
            {t('plus.partnership-cta.title')}
          </h2>
          <ViverseButton asChild size="medium" variant="default" className="mt-6">
            <a href="mailto:services@viverse.com">{t('plus.partnership-cta.button')}</a>
          </ViverseButton>
        </div>
      </motion.div>
    </section>
  )
}
